import { render, staticRenderFns } from "./dadataSuggestPassport.vue?vue&type=template&id=cef2f552&scoped=true"
import script from "./dadataSuggestPassport.vue?vue&type=script&lang=js"
export * from "./dadataSuggestPassport.vue?vue&type=script&lang=js"
import style0 from "./dadataSuggestPassport.vue?vue&type=style&index=0&id=cef2f552&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef2f552",
  null
  
)

export default component.exports